import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, OnInit, Output } from '@angular/core';
import { NutrientType } from '@app/shared/components/nutrients-list/nutrients';
import { IconName } from '@app/shared/utils/icon/icons';
import { nutrientInfographyMock } from './nutritional-assessment';
import { GTMService, PageBlockEnum, patientBlockDisplay } from '@app/core/services/tracking';
import { SupportPageService } from '@app/pages/support-page/services/support-page.service';
import { RcLoaderSize } from '@rc-df/ds-web-components';
import { NutrientBarComponent } from '../nutrient-bar/nutrient-bar.component';
import { NutrientsListComponent } from '../nutrients-list/nutrients-list.component';
import { NutrientsBenefitsListComponent } from '../nutrients-benefits-list/nutrients-benefits-list.component';
import { LoaderComponent } from '../../../core/components/loader/loader.component';
import { NoResultsComponent } from '../no-results/no-results.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@app/shared/pipes';
import { SmartRecoFacade } from '@app/pages/smart-reco/store/smart-reco.facade';

@Component({
  selector: 'app-nutritional-assessment',
  templateUrl: './nutritional-assessment.component.html',
  styleUrls: ['./nutritional-assessment.component.scss'],
  imports: [
    NutrientBarComponent,
    NutrientsListComponent,
    NutrientsBenefitsListComponent,
    LoaderComponent,
    NoResultsComponent,
    AsyncPipe,
    TranslatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NutritionalAssessmentComponent implements OnInit {
  @Output() submitted = new EventEmitter();

  public macroNutrients$ = this.smartRecoFacade.nutritionalAssessmentMacronutrients$;
  public otherNutrients$ = this.smartRecoFacade.nutritionalAssessmentOtherNutrients$;
  public benefitClaim$ = this.smartRecoFacade.nutritionalAssessmentBenefitClaim$;
  public nutritionalAssessmentHasError$ = this.smartRecoFacade.nutritionalAssessmentHasError$;
  public nutritionalAssessmentLoading$ = this.smartRecoFacade.nutritionalAssessmentLoading$;
  public readonly IconName = IconName;
  public readonly NutrientType = NutrientType;
  public nutrientsMock = nutrientInfographyMock;
  public xrayFAQPdfUrl$ = this.supportPageService.getXrayFAQLink$();

  public rcLoaderSize: RcLoaderSize = 'medium';

  constructor(
    private trackingService: GTMService,
    private supportPageService: SupportPageService,
    private readonly smartRecoFacade: SmartRecoFacade,
  ) {}

  public ngOnInit(): void {
    this.trackingService.sendInteraction(
      patientBlockDisplay({
        block: PageBlockEnum.NUTRITIONAL_ASSESSMENT,
      }),
    );
  }

  submitRecommendation(): void {
    this.submitted.emit();
  }

  retryGetNutritionalAssessment(): void {
    this.smartRecoFacade.getSmartRecoNutritionalAssessment();
  }
}
